import { QUERY_CONFIGS } from './queryConfigTypes';
import { createApiFetchFn, generateQueryKey, getApiUrlComponents, QueryConfigTypes } from '../../apis-infra';
import { getSharedPremiumResource } from '../../premium-api/getSharedPremiumResource';
import { PremiumSharedResource } from '../../premium-api/types';
import { mergeQueryOptions } from './internal';
export const createApiQueryOptions = _ref => {
  var _methodConfig$queryCo;
  let {
    methodConfig
  } = _ref;
  const apiConfig = methodConfig.service;
  const queryConfigType = (_methodConfig$queryCo = methodConfig == null ? void 0 : methodConfig.queryConfigType) != null ? _methodConfig$queryCo : apiConfig.defaultQueryConfigType;
  const reactQueryOptions = methodConfig == null ? void 0 : methodConfig.reactQueryOptions;
  const queryConfig = methodConfig.isMutating ? QUERY_CONFIGS[QueryConfigTypes.MUTATION_METHOD] : queryConfigType ? QUERY_CONFIGS[queryConfigType] : {};
  const fetchFn = createApiFetchFn({
    methodConfig
  });
  return _ref2 => {
    var _methodConfig$service;
    let {
      httpClient,
      request,
      options
    } = _ref2;
    return {
      ...queryConfig,
      ...reactQueryOptions,
      ...mergeQueryOptions(options, {
        meta: {
          tags: methodConfig.tags,
          request,
          methodName: methodConfig == null ? void 0 : methodConfig.name,
          serviceName: methodConfig == null ? void 0 : (_methodConfig$service = methodConfig.service) == null ? void 0 : _methodConfig$service.name
        }
      }),
      queryKey: generateQueryKey(methodConfig, request),
      queryFn: async () => {
        var _methodConfig$tags;
        const result = await fetchFn({
          httpClient,
          request
        });
        if (methodConfig.isMutating && (_methodConfig$tags = methodConfig.tags) != null && _methodConfig$tags.length) {
          invalidateQueriesByTags(...methodConfig.tags);
        }
        return result;
      }
    };
  };
};
export function invalidateAllQueries() {
  const queryClient = getSharedPremiumResource(PremiumSharedResource.QueryClientInstance);
  queryClient == null ? void 0 : queryClient.invalidateQueries();
}
export function invalidateQueries() {
  var _args$;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (!(args != null && args.length)) {
    return;
  }
  const isTags = typeof args[0] === 'string' && ((_args$ = args[0]) == null ? void 0 : _args$[0]) === '#';
  isTags ? invalidateQueriesByTags(...args) : invalidateQueriesByMethods(...args);
}
function invalidateQueriesByTags() {
  for (var _len2 = arguments.length, tags = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    tags[_key2] = arguments[_key2];
  }
  if (!(tags != null && tags.length)) {
    return;
  }
  const queryClient = getSharedPremiumResource(PremiumSharedResource.QueryClientInstance);
  queryClient == null ? void 0 : queryClient.invalidateQueries({
    predicate: query => query.queryKey.filter(key => {
      var _key$;
      return typeof key === 'string' && ((_key$ = key[0]) == null ? void 0 : _key$[0]) === '#';
    }).some(key => tags.includes(key)),
    refetchActive: true,
    refetchInactive: false
  }).then().catch();
}
function invalidateQueriesByMethods() {
  for (var _len3 = arguments.length, methods = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    methods[_key3] = arguments[_key3];
  }
  methods.forEach(invalidateQuery);
}
export const invalidateQuery = methodConfig => {
  if (!methodConfig) {
    return;
  }
  const queryClient = getSharedPremiumResource(PremiumSharedResource.QueryClientInstance);
  queryClient == null ? void 0 : queryClient.invalidateQueries({
    queryKey: getApiUrlComponents(methodConfig),
    exact: false,
    // predicate: (query) =>
    //   query.queryKey[0] === serviceConfig.baseUrl &&
    //   (query.queryKey[1] === methodConfig?.path ||
    //     query.queryKey[1] === methodName),
    refetchActive: true,
    refetchInactive: false
  }).then().catch();
};
//# sourceMappingURL=createApiQueryOptions.js.map